import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import { SubmitGhgRatingChangeRequest } from "../../../../../models/ghgs/ghg.models";
import { GhgService } from '../../../../../services/ghg/ghg.service';
import { Router } from 'aurelia-router';
import { RightShipQiRouterConstants } from '../../../../../configuration/rightshipqi-router.constants';

@transient()
@autoinject
export class DisclaimerConfirmationDialog {

    public model: SubmitGhgRatingChangeRequest;
    public onValidationError: (validationResult: any) => void;

    constructor(private dialogClientService: DialogClientService, private ghgService: GhgService, private router: Router) {

    }

    activate(model: { model: SubmitGhgRatingChangeRequest, onValidationError: (validationResult: any) => void }) {
        this.model = model.model;
        this.onValidationError = model.onValidationError;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async continue() {
        await this.ghgService.submitGhgRatingChange(this.model).then(x => {
            if (x.validationResult && x.validationResult.hasError) {
                this.onValidationError(x.validationResult);
            } else {
                this.dialogClientService.hide();

                this.router.navigateToRoute(RightShipQiRouterConstants.GhgRatingChangeRouteNames.GhgRatingChangeReport);
            }
        });
    }
}